module.exports = __webpack_public_path__ + "static/media/March2021Newsletter.0c0a6843.pdf";